import "./banner/Banner.css";
import Banner from "./banner/Banner";
import How_It_works from "./how-It-works/How_It_works";
import Core_benefits from "./core_benefits/Core_benefits";
import Get_App from "./get-app/Get_App";
import FAQ from "../common/faq/FAQ";

function Home() {
  return (
    <>
      <Banner />
      <How_It_works />
      <Core_benefits />
      <Get_App />
      <FAQ/>
    </>
  );
}

export default Home;
